import React, { ReactNode } from 'react';

interface TooltipProps {
  text: string;
  children: ReactNode;
  position?: 'top' | 'bottom';
}

export const Tooltip: React.FC<TooltipProps> = ({ text, children, position = 'top' }) => {
  const isTop = position === 'top';

  return (
    <div className="group relative inline-flex">
      {children}
      <div 
        className={`
          absolute left-1/2 -translate-x-1/2 px-3 py-2 
          bg-slate-950 border border-slate-700 text-slate-300 text-xs rounded-md 
          opacity-0 group-hover:opacity-100 transition-opacity duration-200 
          pointer-events-none w-max max-w-[220px] shadow-xl z-50 text-center leading-snug backdrop-blur-sm
          ${isTop ? 'bottom-full mb-2' : 'top-full mt-2'}
        `}
      >
        {text}
        {/* Arrow */}
        <div 
          className={`
            absolute left-1/2 -translate-x-1/2 border-4 border-transparent
            ${isTop ? 'top-full -mt-1 border-t-slate-700' : 'bottom-full -mb-1 border-b-slate-700'}
          `} 
        />
      </div>
    </div>
  );
};